export default "__VITE_ASSET__eu$Whz7j__"